export default "__VITE_ASSET__D1HlgyBG__"